//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "UiBetslipComboBoostBanner",
  props: {
    showComboBoost: {
      type: Boolean,
      required: true,
    },
    comboBoostOptin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async displayComboBoostOptin() {
      const api_new = "/api/cms/content?url=combo-boost";

      try {
        // Fetch promotion data from the API
        const response = await this.$new_cms().get(api_new);
        const promotion = response?.data?.data;

        // Open the modal with fetched promotion data
        this.$modal.show("modal-combo-boost-promotion", {
          promotion,
          closedCb: this.modalClosed,
        });
      } catch (error) {
        console.error("Failed to fetch promotion data:", error);
      }
    },

  }
};
